import { useWatch } from 'react-hook-form'
import { useIntl } from '@/intl'
import { PasswordInput } from '@/scopes/common/components/FormElements/PasswordInput'
import { buildPasswordHelperRules } from './passwordHelperRules'
import { passwordValidations } from './passwordValidations'

interface NewPasswordInputProps {
  name: string
  disabled?: boolean
}

export function NewPasswordInput({ name, disabled }: NewPasswordInputProps) {
  const intl = useIntl()
  const password: string = useWatch({ name }) ?? ''

  const helperRules = buildPasswordHelperRules(password, {
    minLength: intl.formatMessage({ id: 'auth_form_password_rule_min_length' }),
    number: intl.formatMessage({ id: 'auth_form_password_rule_number' }),
    lowerCase: intl.formatMessage({ id: 'auth_form_password_rule_lower_case' }),
    upperCase: intl.formatMessage({ id: 'auth_form_password_rule_upper_case' }),
  })

  return (
    <PasswordInput
      name={name}
      label={intl.formatMessage({ id: 'auth_form_password_label' })}
      required
      requiredErrorMessage={intl.formatMessage({ id: 'auth_form_password_required_error' })}
      showPasswordLabel={intl.formatMessage({ id: 'auth_form_password_show_label' })}
      hidePasswordLabel={intl.formatMessage({ id: 'auth_form_password_hide_label' })}
      autoComplete="new-password"
      helperRules={helperRules}
      validations={passwordValidations}
      disabled={disabled}
    />
  )
}
